<template>
  <footer class="bg-gradient-to-b from-brand-700 to-[#0A0908]">
    <div class="w-full px-3 py-8 tablet:px-4 desktop:px-6 desktop:py-12">
      <div class="grid grid-cols-1 gap-6 desktop:grid-cols-4 desktop:pb-12">
        <LayoutFooterColumn
          v-for="column in columns"
          :key="column.title"
          :title="column.title"
          :links="column.links"
        />
      </div>

      <div
        class="mt-8 grid grid-cols-1 items-end gap-6 desktop:mt-0 desktop:grid-cols-4"
      >
        <div class="desktop:col-span-3">
          <div class="mb-3 flex items-center gap-2 px-3 tablet:mb-2">
            <TheNuxtLink
              v-for="item in socialItems"
              :key="item.name"
              :to="item.url"
              :title="item.name"
              class="flex h-7 w-7 items-center justify-center rounded-full bg-gray-600_a15 text-white hover:bg-gray-600_a25 active:bg-gray-600_a35 tablet:h-9 tablet:w-9"
            >
              <component
                :is="item.icon"
                class="h-6 w-6 tablet:h-7 tablet:w-7"
              />
            </TheNuxtLink>
          </div>

          <div
            class="flex flex-col flex-wrap gap-x-5 gap-y-4 px-3 text-sm leading-6 text-white tablet:flex-row"
          >
            <p>© 1983-{{ thisYear }} Advantech Co., Ltd.</p>
            <TheNuxtLink
              v-for="item in legalLinks"
              :key="item.name"
              :to="item.url"
              :title="item.name"
              class="block text-xs underline tablet:text-sm"
            >
              {{ item.name }}
            </TheNuxtLink>
          </div>
        </div>

        <LayoutFooterLocale
          class="tablet:ml-auto tablet:w-1/2 desktop:w-full"
        />
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
  import type { Component } from 'vue';

  import IconBilibili from '@/components/Icon/Bilibili.vue';
  import IconFacebook from '@/components/Icon/Facebook.vue';
  import IconLinkedin from '@/components/Icon/Linkedin.vue';
  import IconQq from '@/components/Icon/Qq.vue';
  import IconWechat from '@/components/Icon/Wechat.vue';
  import IconYoutube from '@/components/Icon/Youtube.vue';

  const dayjs = useDayjs();
  const { columns, socialLinks, legalLinks } = useFooterMenu();

  const thisYear = computed((): string => dayjs().format('YYYY'));

  const iconMap: Record<string, Component> = {
    IconQq,
    IconWechat,
    IconBilibili,
    IconYoutube,
    IconFacebook,
    IconLinkedin,
  };

  const socialItems = socialLinks.value.map((item) => ({
    ...item,
    icon: iconMap[item.icon],
  }));
</script>
